module.exports = __webpack_public_path__ + "img/2.f3e20d5e.jpg";